import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { HardHat, Search } from "lucide-react";

export default function SitesList() {
  const [items, setItems] = useState([]);
  const [companies, setCompanies] = useState({});
  const [q, setQ] = useState("");
  const [stato, setStato] = useState("");

  useEffect(() => {
    (async () => {
      const [s, c] = await Promise.all([api.get("/sites", { params: { q, stato: stato || undefined } }), api.get("/companies")]);
      setItems(s.data);
      setCompanies(Object.fromEntries(c.data.map(x => [x.id, x])));
    })();
  }, [q, stato]);

  return (
    <div className="space-y-6">
      <header>
        <div className="text-xs font-mono uppercase tracking-widest text-blue-700 mb-1">Anagrafica</div>
        <h1 className="font-display text-3xl font-bold text-slate-900 flex items-center gap-2"><HardHat size={28} /> Cantieri</h1>
      </header>
      <div className="flex flex-wrap gap-3 items-center">
        <div className="relative flex-1 min-w-64 max-w-md">
          <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
          <input placeholder="Cerca denominazione, indirizzo, committente…" value={q} onChange={(e) => setQ(e.target.value)}
            className="w-full pl-10 pr-3 py-2.5 border border-slate-300 rounded-lg bg-white" />
        </div>
        <select value={stato} onChange={(e) => setStato(e.target.value)} className="px-3 py-2.5 border border-slate-300 rounded-lg bg-white">
          <option value="">Tutti gli stati</option>
          <option value="attivo">Attivi</option>
          <option value="sospeso">Sospesi</option>
          <option value="chiuso">Chiusi</option>
        </select>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {items.map(s => (
          <Link key={s.id} to={`/cantieri/${s.id}`} className="card-lift block bg-white border border-slate-200 rounded-lg p-4">
            <div className="flex items-start justify-between">
              <div>
                <div className="font-display font-semibold text-slate-900">{s.denominazione}</div>
                <div className="text-sm text-slate-600 mt-1">{s.committente}</div>
              </div>
              <span className={`status-pill ${s.stato === "attivo" ? "status-valid" : s.stato === "sospeso" ? "status-expiring" : "status-expired"}`}>{s.stato}</span>
            </div>
            <div className="text-xs text-slate-500 mt-2">{s.indirizzo}</div>
            <div className="text-xs text-blue-700 mt-2">{companies[s.company_id]?.ragione_sociale}</div>
          </Link>
        ))}
        {items.length === 0 && <div className="col-span-full text-center text-slate-500 py-10">Nessun cantiere.</div>}
      </div>
    </div>
  );
}
